/* global axios */
import ApiClient from "dashboard/api/ApiClient";

class CRMDealsAPI extends ApiClient {
  constructor() {
    super("crm/deals", { accountScoped: true });
  }

  get({ pipelineId, stageId, page, perPage, ownerId, ownerIds, status, contactId, phone, conversationId, titleSearch, productId, amountMin, amountMax, createdFrom, createdTo, structureOnly } = {}) {
    const params = {};

    if (pipelineId)    params.pipeline_id   = pipelineId;
    if (stageId)       params.stage_id      = stageId;
    if (page)          params.page          = page;
    if (perPage)       params.per_page      = perPage;
    // ownerIds (array) tiene prioridad sobre ownerId (singular, retrocompatible)
    if (ownerIds?.length > 0) params.owner_id = ownerIds;
    else if (ownerId)          params.owner_id = ownerId;
    if (status)        params.status        = status;
    if (contactId)     params.contact_id    = contactId;
    if (phone)         params.phone         = phone;
    if (conversationId) params.conversation_id = conversationId;
    if (titleSearch)    params.title_search    = titleSearch;
    if (productId)      params.product_id      = productId;
    if (amountMin != null) params.amount_min   = amountMin;
    if (amountMax != null) params.amount_max   = amountMax;
    if (createdFrom)    params.created_from    = createdFrom;
    if (createdTo)      params.created_to      = createdTo;
    if (structureOnly)  params.structure_only  = '1';

    return axios.get(this.url, { params });
  }

  getAll() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  move({ id, stageId, formData = null }) {
    const payload = { stage_id: stageId };
    if (formData) {
      payload.form_data = formData;
    }
    return axios.patch(`${this.url}/${id}/move`, payload);
  }

  reorder({ id, position }) {
    return axios.patch(`${this.url}/${id}/reorder`, { position });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.put(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CRMDealsAPI();
